export function formatDobInputYYYYMMDD(raw: string): string {
  const digits = (raw ?? '').replace(/[^0-9]/g, '').slice(0, 8)
  if (digits.length <= 4) return digits
  if (digits.length <= 6) return `${digits.slice(0, 4)}/${digits.slice(4)}`
  return `${digits.slice(0, 4)}/${digits.slice(4, 6)}/${digits.slice(6)}`
}

export function getCaretPosForDigitIndex(formatted: string, digitIndex: number): number {
  if (digitIndex <= 0) return 0
  let seen = 0
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      seen++
      if (seen >= digitIndex) return i + 1
    }
  }
  return formatted.length
}

